<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>

<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;;">Downloading Document</span></div>
<div>

    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;">
       <p>Stand by while we download your document.  It will open in another tab.</p>
        
       <div style="margin-left:10px;margin-right:30px;margin-top:30px;">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
       </div>
    </div>
</div>
